//Styles
import Styles from "./Display.module.scss"; 

const Display = () => {
  return (
    <div className={Styles.container}>
        <div className="top_container">
            
        </div>
    </div>
  )
}

export default Display
